import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CompanyLogo from './components/CompanyLogo';
import LoginForm from './components/LoginForm';
import SecurityIndicators from './components/SecurityIndicators';
import LoginCredentialsHelper from './components/LoginCredentialsHelper';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authToken = localStorage.getItem('Token');
    if (authToken) {
      navigate('/admin-dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Main Login Card */}
        <div className="bg-white rounded-xl shadow-elevation-3 border border-border p-8">
          {/* Company Logo Section */}
          <CompanyLogo />
          
          {/* Login Form */}
          <LoginForm />
          
     
        </div>
        
    
  
      </div>
    </div>
  );
};

export default Login;